function event(name: string, inputType: string | null = null): Event {

    const event: Event = new Event(name, {bubbles: true, cancelable: true})

    if (inputType) {
        Object.defineProperty(event, 'inputType', {
            value: inputType,
            writable: false,
            configurable: true,
            enumerable: true
        })
    }

    return event
}

function findInputElement(el: any): HTMLInputElement {

    return (el instanceof HTMLInputElement) ? el : el.querySelector('input') || el
}

function fixInputSelection(el: HTMLInputElement, position: number, digit: number): void {

    while (position && position < el.value.length && el.value.charAt(position - 1) !== String(digit)) {

        position++
    }

    const selectionRange = el.type
        ? el.type.match(/^(text|search|password|tel|url)$/i)
        : !el.type

    if (selectionRange && el === document.activeElement) {

        el.setSelectionRange(position, position)

        setTimeout(() => el.setSelectionRange(position, position), 0)
    }
}

function isString(val: any): boolean {
    return Object.prototype.toString.call(val) === '[object String]'
}

export {
    event,
    findInputElement,
    fixInputSelection,
    isString
}
